export function AsessmentReviewMsgEnglish(
  answered,
  TotalQuestions,
  remaningtime,
  subjectname
) {
  const AlertMessage =
    answered !== TotalQuestions ? (
      <>
        You answered only <b className="text-success">{answered}</b> question(s)
        out of<b className="text-primary"> {TotalQuestions}</b>, and{" "}
        <b style={{ color: "orangered" }}>{TotalQuestions - answered} </b>{" "}
        question(s) are unanswered. You have{" "}
        <b className="RemaningTime"> {remaningtime}</b>
        more minutes to complete the remaining question(s). Do you want to
        continue with {subjectname}?
      </>
    ) : (
      <>
        {" "}
        You have <b className="RemaningTime">{remaningtime}</b> more minutes to
        review question(s)/answers. Do you want to continue to review?
      </>
    );

  const BackToSubject = `Yes, I want to continue with ${subjectname}`;
  const NextSubject1 = `No, I would like to submit ${subjectname}`;
  const NextSubject2 = `I know i cannot go back to ${subjectname}`;
  const ReviewandSubmit = `Review and Submit - ${subjectname}`;

  return [
    AlertMessage,
    BackToSubject,
    NextSubject1,
    NextSubject2,
    ReviewandSubmit,
  ];
}

export function AsessmentReviewMsgHindi(
  answered,
  TotalQuestions,
  remaningtime,
  subjectname
) {
  const AlertMessage =
    answered !== TotalQuestions ? (
      <>
        आपने कुल <b className="text-primary">{TotalQuestions}</b> में से केवल{" "}
        <b className="text-success">{answered}</b> प्रश्नों के उत्तर दिए हैं।
        आपके पास शेष प्रश्नों को हल करने के लिए{" "}
        <b className="RemaningTime">{remaningtime}</b> मिनट बचेहैं। क्या आप{" "}
        {subjectname} के साथ जारी रखना चाहते हैं?
      </>
    ) : (
      <>
        आपके पास प्रश्नों/उत्तरों की समीक्षा करने के लिए{" "}
        <b className="RemaningTime">{remaningtime}</b> मिनट शेष हैं। क्या आप
        समीक्षा जारी रखना चाहते हैं?
      </>
    );

  const BackToSubject = `हाँ, मैं ${subjectname} के साथ जारी रखना चाहता/चाहती हूँ`;
  const NextSubject1 = `नहीं, मैं ${subjectname} सबमिट करना चाहता/चाहती हूँ`;
  const NextSubject2 = `मुझे पता है कि मैं ${subjectname} पर वापस नहीं जा सकूंगा/ सकूंगी`;
  const ReviewandSubmit = `समीक्षा करें और सबमिट करें  - ${subjectname}`;

  return [
    AlertMessage,
    BackToSubject,
    NextSubject1,
    NextSubject2,
    ReviewandSubmit,
  ];
}

export function SubjectSubmissionMsgEnglish(
  TextRelated,
  subjectname,
  lastSubject,
  NextTest
) {
  const AssessmentData = JSON.parse(localStorage.getItem("AssessmentData"));
  const AlertMessage = TextRelated ? (
    <span>
      You have successfully submitted <b>{subjectname}</b> Assessment.{" "}
      {lastSubject ? (
        AssessmentData?.testType === "single" ? (AssessmentData?.subjectNo === 3 ? <> Your Assessment Feed Back will be loaded shortly…</>
          : <> Your Assessment Score card will be loaded shortly…</>) : <> Your Assessment Feed Back will be loaded shortly…</>
        // ""
      ) : (
        <>
          <b>{NextTest}</b> Assessment will be loaded shortly…
        </>
      )}
    </span>
  ) : (
    <span>
      {" "}
      Oops, the assessment time is up, and <b> {subjectname}</b> Assessment has
      been submitted automatically.
      <b> {NextTest}</b> Assessment will be loaded shortly…
    </span>
  );

  return [AlertMessage];
}

export function SubjectSubmissionMsgHindi(
  TextRelated,
  subjectname,
  lastSubject,
  NextTest
) {
  const AssessmentData = JSON.parse(localStorage.getItem("AssessmentData"));
  const AlertMessage = TextRelated ? (
    <span>
      आपने सफलतापूर्वक <b>{subjectname}</b> परीक्षा (असेसमेंट) सबमिट कर दिया है।{" "}
      {lastSubject ? (
        AssessmentData?.testType === "single" ? (AssessmentData?.subjectNo === 3 ? <> आपका मूल्यांकन फ़ीड वापस शीघ्र ही लोड हो जाएगा...</>
          : <> आपका मूल्यांकन स्कोर कार्ड शीघ्र ही लोड हो जाएगा...</>) : <> आपका मूल्यांकन फ़ीड वापस शीघ्र ही लोड हो जाएगा...</>
        // <> आपका मूल्यांकन स्कोर शीघ्र ही लोड हो जाएगा…</>
        // ""
      ) : (
        <>
          <b>{NextTest}</b> का मूल्यांकन शीघ्र ही लोड होगा...
        </>
      )}
    </span>
  ) : (
    <span>
      {" "}
      ओह, मूल्यांकन का समय समाप्त हो गया है, और <b> {subjectname}</b> मूल्यांकन
      स्वचालित रूप से प्रस्तुत किया गया है.
      <b> {NextTest}</b>मूल्यांकन शीघ्र ही लोड किया जाएगा…
    </span>
  );

  return [AlertMessage];
}
